// extracted by mini-css-extract-plugin
export var button = "notification-settings-form-module--button--OeUp1";
export var buttonBox = "notification-settings-form-module--button-box--IEKez";
export var checkbox = "notification-settings-form-module--checkbox--r0dgb";
export var checkboxAll = "notification-settings-form-module--checkbox-all--OGhuH";
export var form = "notification-settings-form-module--form--KnKs+";